<template>
  <template v-if="show">
    <slot></slot>
  </template>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'

const show = ref<boolean>(false)

onMounted(() => {
  show.value = true
})
</script>
